import {
  Component,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AgFilterComponent } from '@ag-grid-community/angular';
import {
  IFilterParams,
  IDoesFilterPassParams,
  IAfterGuiAttachedParams,
} from '@ag-grid-community/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from 'src/app/services/log.service';
import { Subscription} from 'rxjs';
import * as GridFilterActions from '@state/actions/filter.action';
import { TapAppStore } from '@state/tap-state';

@Component({
  selector: 'app-skytank-filter',
  templateUrl: './skytank-filter.component.html',
  styleUrls: ['./skytank-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkytankFilterComponent implements AgFilterComponent, AfterViewInit, OnDestroy {
  params: IFilterParams;
  formGroup: FormGroup;

  filterType: string = '';
  filterValues: string[] = [];
  _isFilterActive: boolean = false;
  filterValueHasChanged: boolean = false;

  private get allSkytankGatewaysFormControl() {
    return this.formGroup.get('allSkytankGateways');
  }

  private subscriptions: Subscription[] = [];

  private storeIsFilterActive = false;
  private isFilterActiveSub = null;

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private logger: LogService,
    private cdr: ChangeDetectorRef,
    private tapAppStore: TapAppStore
  ) {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }

  // Implement required ag-grid filter methods
  agInit(params: IFilterParams): void {
    try {
      this.logger?.log?.('SkyTank Filter Params:', params);
      this.params = params;

      // Ensure form is built
      if (!this.formGroup) {
        this.buildForm();
      }

      this.isFilterActiveSub = this.tapAppStore.store
        .select(state => state.gridFilter['includeAllGateways'])
        .subscribe(val => {
          this.logger.log('Received includeAllGateways from store:', val);
          this.storeIsFilterActive = val === undefined || val === null ? false : val;
          this.formGroup
            ?.get('allSkytankGateways')
            .setValue(this.storeIsFilterActive, { emitEvent: false });
          this.params.filterChangedCallback();
          this.cdr.detectChanges();
        });
      this.subscriptions.push(this.isFilterActiveSub);

    } catch (error) {
      console.error('Error in agInit:', error);
    }
  }

  afterGuiAttached(params: IAfterGuiAttachedParams): void {

  }


  isFilterActive(): boolean {
    // Get external state from store instead of using internal _isFilterActive`
    return this.storeIsFilterActive;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    //not used - Client side row model uses this not server side row
    return true;
  }

  getModel() {
    return null;
  }

  setModel(model: any) {}

  buildForm(): void {
    this.formGroup = this.formBuilder.group({
      allSkytankGateways: [false],
    });
    this.subscriptions.forEach(sub => sub.unsubscribe());
    const formSub = this.formGroup.valueChanges.subscribe(newValues => {
      this.filterValueHasChanged = true;
      this.cdr.markForCheck();
    });
    this.subscriptions.push(formSub);
  }

  applyFilterValue(): void {
    this._isFilterActive = this.allSkytankGatewaysFormControl.value;
    this.updateFilter();
  }

  clearFilter(): void {
    try {
      this.filterType = '';
      this.filterValues = [];
      this._isFilterActive = false;

      // Make sure form is initialized
      if (!this.formGroup) {
        this.buildForm();
      }

      // Reset form values
      if (this.formGroup) {
        this.formGroup.patchValue({ allSkytankGateways: false }, { emitEvent: false });
      }

      this.filterValueHasChanged = true;

      if (this.params) {
        this.updateFilter();
      }
    } catch (error) {
      this.logger?.error('Error in clearFilter:', error);
    }
  }

  updateFilter(): void {
    try {
      if (this.storeIsFilterActive === this._isFilterActive) return;

      this.tapAppStore.store.dispatch(new GridFilterActions.ShowAllGateways(this._isFilterActive));
      //this.params.filterChangedCallback();
    } catch (error) {
      this.logger?.error('Error in updateFilter:', error);
    }
  }

  disableReset(): boolean {
    return !this.formGroup?.get('allSkytankGateways')?.value;
  }

  disableApply(): boolean {
    return !this.filterValueHasChanged;
  }
}
